import { useCallback } from 'react';

import ROUTES from '@/common/routes';
import { useHistory } from '@/modules/core/hooks';
import { EMAIL_QUERY_KEY, IS_FORGOT_PASSWORD_KEY, USERNAME_QUERY_KEY } from '@/modules/user/components/SignUp/signUp.constants';
import { useResendConfirmationCodeQuery } from '@/modules/user/queries';

interface Props {
  username: string;
  email?: string;
}

const useHandleUnconfirmedUserError = () => {
  const { push } = useHistory();
  const { resendSignUpCode } = useResendConfirmationCodeQuery();

  const handleUnconfirmedUserError = useCallback(async ({ username, email }: Props) => {
    if (email) {
      push(`${ROUTES.VERIFY}?${USERNAME_QUERY_KEY}=${username}&${EMAIL_QUERY_KEY}=${email}&${IS_FORGOT_PASSWORD_KEY}=true`);
      return;
    }

    const response = await resendSignUpCode({
      username,
    });
  
    const userEmail = response?.data?.destination;
    push(`${ROUTES.VERIFY}?${USERNAME_QUERY_KEY}=${username}&${EMAIL_QUERY_KEY}=${userEmail}`);
  }, [push, resendSignUpCode]);

  return {
    handleUnconfirmedUserError,
  };
};

export default useHandleUnconfirmedUserError;
